/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import HelpButton from 'app/components/common/HelpButton.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import { Link } from 'react-router-dom';
import OutputConfigModal from 'app/components/OutputConfigModal/OutputConfigModal.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import SocialAvatarTab from 'app/components/common/SocialAvatarTab.jsx';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import Utilities from 'app/utility/Utilities.js';
import { Breakpoint } from 'react-socks';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import makeToast from 'app/modules/makeToast.js';
import SocialRestoreModule from 'app/modules/SocialRestoreModule.jsx';

import { compose } from 'redux';

class RouteDetailSocials extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			rolloverID: 0,
			duplicateSocial: null,
			mobileListVisible: false
		};

		this.showConnectModal = this.showConnectModal.bind(this);
		this.onConnect = this.onConnect.bind(this);
		this.toggleOutput = this.toggleOutput.bind(this);
		this.viewSocial = this.viewSocial.bind(this);
		this.removeSocial = this.removeSocial.bind(this);
		this.showOutputConfigModal = this.showOutputConfigModal.bind(this);
		this.toggleMobileList = this.toggleMobileList.bind(this);

	}

	componentDidMount() {

		if (this.props.router.query && this.props.router.query.add !== undefined) {
			let cleanUrl = this.props.router.location.pathname.replace(/\?\w+/, "");
			this.props.router.navigate(cleanUrl);
			this.showConnectModal("chooseType");
		}

	}

	showConnectModal(activeTab, e) {

		let modal = (
			<SocialModal
				{...this.props}
				activeRoute={this.props.route}
				routeId={this.props.routeId}
				outputs={this.props.outputs}
				context="list"
				router={this.props.router}
				recordPath={this.props.recordPath}
				activeTab={activeTab}
				connectHandler={this.onConnect} />
		);

		if (e) {
			e.preventDefault();
		}

		// if (this.props.user.perms.resources.outputsAvailable === 0) {
		// 	this.props.showUpgradeModal(this.setModal, 'socials', null, 'social_banner');
		// } else {
			this.props.addModal(modal);
		// }

	}

	onConnect(e) {

		let singleTwitter = true,
			constants = this.props.app.config.constants,
			modal = null;

		if (this.props.route.inputs) {
			if (this.props.route.inputs.length === 1 && this.props.route.inputs[0].type == constants.INPUT_TYPE_TWITTER) {
				singleTwitter = false;
			}
		}

		modal = (
			<SocialModal
				{...this.props}
				activeRoute={this.props.route}
				routeId={this.props.routeId}
				outputs={this.props.outputs}
				context="config"
				router={this.props.router}
				recordPath={this.props.recordPath}
				activeTab="chooseType"
				singleTwitter={singleTwitter} />
		);

		e.preventDefault();

		this.props.addModal(modal);

	}

	toggleOutput(e) {

		let outputID = parseInt(e.currentTarget.dataset.id, 10),
			newState = (e.currentTarget.dataset.togglestate === 'true') ? false : true,
			output = null,
			socialActive = null,
			outputActive = null;

		for (let i = 0; i < this.props.outputs.length; ++i) {
			if (this.props.outputs[i].id === outputID) {
				output = Utilities.deepClone(this.props.outputs[i]);
				socialActive = parseInt(output.social.activeFlag, 10);
				outputActive = parseInt(output.activeFlag, 10);
				break;
			}
		}

		if (output !== null) {
			if (newState) {
				if (!outputActive && !socialActive) {
					if (parseInt(output.social.sysActionFlag, 10)) {
						makeToast("Reconnect " + output.social.name + " to activate posting", "warning", {
							action: {
								label: 'Reconnect',
								onClick: () => { this.props.reconnectSocial(output.social); }
							}
						});
						return;
					}
					if (this.props.user.perms.resources.outputsAvailable === 0) {
						this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'automate_socialdetail');
					} else {
						output.social.activeFlag = 1;
						this.props.updateSocial(output.social);
						output.activeFlag = 1;
						this.props.updateOutput(output);
					}
				} else if (!outputActive && socialActive) {
					output.activeFlag = 1;
					this.props.updateOutput(output);
				}
			} else {
				output.activeFlag = 0;
				this.props.updateOutput(output);
			}
		}

	}

	/*
	 * Greyed whenever the destination cannot post right now, which is three
	 * separate switches: the output, the account behind it, and the route as a
	 * whole. The account is the one the avatars used to miss — a live output on a
	 * switched-off social drew at full strength, next to a toggle saying it was
	 * off.
	 */
	outputInactive(output) {

		return parseInt(output.activeFlag, 10) === 0 ||
			parseInt(output.social.activeFlag, 10) === 0 ||
			!this.props.routeActive;

	}

	viewSocial(output, e) {

        if (output.social.link) {
            window.open(output.social.link);
        }

	}

	removeSocial(output, e) {

		let constants = this.props.app.config.constants,
			cancelAction = () => {
				this.props.closeAllModals(null);
			},
			confirmAction = (e) => {
				e.preventDefault();
				this.props.deleteOutput(output.id);
				this.props.closeAllModals();
			},
			context = (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_SIMPLE) ? 'feed' : 'route',
			modal = (
				<DeleteModal
					modalCopy={"Are you sure you want to remove this social from this " + context + "?"}
					cancelAction={cancelAction}
					confirmAction={confirmAction} />
			);

		this.props.addModal(modal);

	}

	showOutputConfigModal(e) {
		let route = null,
			constants = this.props.app.config.constants,
			outputModal = null,
			id = e.currentTarget.dataset.id,
			socialID = 0;

		e.preventDefault();
		e.stopPropagation();

		for (let i = 0; i < this.props.automatedRoutes.list.length; ++i) {
			if (this.props.automatedRoutes.list[i].id == this.props.router.params.routeId) {
				route = this.props.automatedRoutes.list[i];
				break;
			}
		}

		for (let i = 0; i < route.outputs.length; ++i) {
			if (parseInt(route.outputs[i].id, 10) === parseInt(id, 10)) {
				socialID = route.outputs[i].social.id;
				break;
			}
		}

		if (route) {
			outputModal = (
				<OutputConfigModal
					{...this.props}
					outputID={id}
					socialID={socialID}
					name={route.name}
					type={this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED ? constants.INPUT_TYPE_FEED : route.inputs[0].type}
					recordPath={this.props.recordPath} />
			);

			this.props.addModal(outputModal);

		}

	}

	toggleRole(output, e) {

		let constants = this.props.app.config.constants;

		output.role = constants.OR_ROLE_NORMAL;
		this.props.updateOutput(output);

	}

	toggleMobileList(e) {
		this.setState({
			mobileListVisible: !this.state.mobileListVisible
		});
	}

	render() {

		let socialLabel = "",
			isTwitterInput = false,
			constants = this.props.app.config.constants,
			detailList = null,
			displaySocials = null,
			extraSocials = null;

		socialLabel = " Outputs";
		if (this.props.outputs.length === 1) {
			socialLabel = " Output";
		}
		socialLabel = "Posting to " + this.props.outputs.length + socialLabel;

		if (this.props.route.inputs.length) {
			for (var i = 0; i < this.props.route.inputs.length; ++i) {
				if (this.props.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					isTwitterInput = true;
					break;
				}
			}
		}

		detailList = (
			<ul className="detail-list">
			{this.props.outputs.map(function(output, i){
				let inactive = false,
					config = true,
					frozen = true,
					active = (parseInt(output.activeFlag, 10)) ? true : false,
					toggleClass = "inline small",
					warning = null,
					iconAction = null,
					cellIconClass = 'cell-icon',
					retweetClass = 'list-retweet-indicator',
					link = null,
					retweetIcon = null,
					editOutput = null,
					constants = this.props.app.config.constants,
					masterSwitch = null,
					outputName = null,
					activeToggle = null,
					groupConnect = null;

				activeToggle = (
					<ToggleControl
						active={active}
						callback={this.toggleOutput}
						noLabel={true}
						toggleClass={toggleClass}
						data-id={output.id} />
				);

				if (ConstantMixin.getIconIndexByCode(output.social.psID)) {
					toggleClass += " " + ConstantMixin.getIconIndexByCode(output.social.psID);
				}

				inactive = this.outputInactive(output);

				if (parseInt(output.activeFlag, 10) === 0 || !this.props.routeActive) {
					frozen = false;
					if (!this.props.routeActive || parseInt(output.social.activeFlag, 10) === 0) {
						toggleClass += " route-inactive";
					}
				}


				if (parseInt(output.social.psID, 10) === this.props.app.config.constants.POST_SVC_FEED) {
					config = false;
				}

				if (parseInt(output.social.activeFlag, 10) === 0) {
					iconAction = () => { this.props.restoreSocial(output.social); };
					cellIconClass += ' clickable';
				}

				if (parseInt(output.social.psID, 10) === constants.POST_SVC_TWITTER) {
					retweetClass = (!active) ? retweetClass + " inactive" : retweetClass;
					if (isTwitterInput || output.role == constants.OR_ROLE_RETWEET) {
						retweetIcon = (
							<span className={retweetClass} alt="Retweeting content" title="Retweeting content"><i className="ds-icon icon-retweet"/></span>
						);
					}
				}

				if (parseInt(output.social.sysActionFlag, 10)) {
					if (!output.social.subType ||
						!(
							parseInt(output.social.psID, 10) === constants.POST_SVC_FACEBOOK &&
							parseInt(output.social.subType, 10) === constants.FB_PROFILE
						)
					) {
						warning = (
							<div className="status-action" alt="Reconnect Social" title="Reconnect Social" onClick={() => {
								this.props.reconnectSocial(output.social);
							}} role="button" aria-label="reconnect social">
								<img src={`${this.props.app.config.assetsUrl}/${this.props.app.config.imageUrl}misc/broken_link.svg`} alt="Reconnect Social"/>
							</div>
						);
					}
				}

				if (output.social.hasGroupApp !== undefined && output.social.hasGroupApp === 0) {
					groupConnect = (
						<div className="status-action" alt="Connect dlvr.it to Facebook Group" title="Connect dlvr.it to Facebook Group" onClick={() => {
								this.props.router.navigate(this.props.router.location + "?group=true");
							}} role="button" aria-label="connect dlvr.it to facebook group">
							<i className="fa fa-chain-broken sys-action"></i>
						</div>
					);
				}

				if (output.social.link) {
					link = (
						<div className="status-action" alt="View Social Page" title="View Social Page" onClick={this.viewSocial.bind(this, output)} role="button" aria-label="view social page">
							<i className="fa fa-external-link"></i>
						</div>
					);
				}

				/*
				 * All non-twitter accounts should be editable.
				 * Twitter accounts are editable if there is not a twitter input
				 * and they're not marked as retweeters
				 */
				let isTwitterOutput = parseInt(output.social.psID, 10) == constants.POST_SVC_TWITTER;
				if (!isTwitterOutput || (!isTwitterInput && output.role == constants.OR_ROLE_NORMAL && isTwitterOutput)) {
					editOutput = (
						<div className="status-action" alt="Edit Output" title="Edit Output" onClick={this.showOutputConfigModal} data-id={output.id} role="button" aria-label="edit">
							<i className="fa fa-cog"></i>
						</div>
					);
					outputName = (
						<span className="social-edit-link clickable" alt={output.social.name} title={output.social.name} onClick={this.showOutputConfigModal} data-id={output.id} role="button" aria-label="edit">
							{output.social.name}
						</span>
					);
				} else {
					editOutput = (
						<div className="status-action inactive" alt="Retweeters arent't editable" title="Retweeters aren't editable">
							<i className="fa fa-ban"></i>
						</div>
					);
					outputName = (
						<span className="social-edit-link">{output.social.name}</span>
					);
				}

				if (!isTwitterInput) {
					if (output.role == constants.OR_ROLE_RETWEET) {
						masterSwitch = (
							<div className="status-action" alt="Make Main Twitter" title="Make Main Twitter" onClick={this.toggleRole.bind(this, output)} role="button" aria-label='make main tweeter'>
								<i className="ds-icon icon-x"/>
							</div>
						);
					} else if (output.role == constants.OR_ROLE_NORMAL && output.social.psID == constants.POST_SVC_TWITTER) {
						masterSwitch = (
							<div className="status-action" alt="This is your Main Twitter" title="This is your Main Twitter" onClick={this.toggleRole.bind(this, output)} role='button' aria-label="this is your main tweeter">
								<i className="ds-icon icon-x" style={{color: '#000'}}/>
							</div>
						);
					}
				}

				if ((parseInt(output.social.psID, 10) === constants.POST_SVC_FACEBOOK && parseInt(output.social.subType, 10) === constants.FB_PROFILE)) {
					warning = (
						<i className="fa fa-times-circle invalid-type"></i>
					);
					activeToggle = null;
					link = null;

					let which = "facebookProfiles";

					editOutput = (
						<HelpButton
							which={which}
							textButton="Profile not supported"/>
					);
				}


				return (
					<li className="list-item social-list" key={output.id}>
						<div className="label-cell">
							<div className={cellIconClass} onClick={iconAction} role="button" aria-label={`go to ${output.social.name}`}>
								<SocialAvatarTab
									social={output.social}
									inactive={inactive}/>
							</div>
							{outputName}
							{retweetIcon}
						</div>
						<div className="action-cell">
							{warning}
							{groupConnect}
							{masterSwitch}
							{activeToggle}
							{link}
							{editOutput}
							<div className="status-action" alt="Remove Output" title="Remove Output" onClick={this.removeSocial.bind(this, output)} role="button" aria-label="remove output">
								<i className="fa fa-trash"></i>
							</div>
						</div>
					</li>
				);
			}, this)}
			</ul>
		);

		if (this.props.outputs.length > 4) {
			extraSocials = (
				<span>+ {this.props.outputs.length - 4} Socials</span>
			);
		}

		let mobileSocials = this.props.outputs.slice(0, 4);
		if (mobileSocials.length) {
			displaySocials = (
				<div className="mobile-social-display" onClick={this.toggleMobileList} role="switch" aria-label="show socials">
					<AccordionControl accordionOpen={this.state.mobileListVisible}/>
					<div className="mobile-top-level-socials">
						{mobileSocials.map((output, i) => {
							return (
								<SocialAvatar
									key={i}
									social={output.social}
									compact={true}
									inactive={this.outputInactive(output)} />
							);
						})}
						{extraSocials}
					</div>
				</div>
			);
		}

		return (
			<div className="detail-block social">
				<Breakpoint desktop only>
					<div className="detail-list-header social">
						<div className="status-label">
							{socialLabel}
						</div>
					</div>
					<div className="detail-list-component">
						<div className="detail-list-wrapper social">
							{detailList}
						</div>
						<div className="add-social-gutter" onClick={this.showConnectModal.bind(this, 'chooseType')} role="button" aria-label="add social">
							<div className="social-gutter-button">
								<span className="gutter-label">
									<i className="fa fa-plus-square"></i>Add Output
								</span>
							</div>
						</div>
					</div>
				</Breakpoint>
				<Breakpoint mobile only>
					<div className="mobile-social-list">
						<div className="add-social-mobile" onClick={this.showConnectModal.bind(this, 'chooseType')} role="button" aria-label="add social">
							<div className="social-gutter-button">
								<span className="gutter-label">
									<i className="fa fa-plus-square"></i>Add Output
								</span>
							</div>
						</div>
						{displaySocials}
						{(this.state.mobileListVisible) ? detailList : null}
					</div>
				</Breakpoint>
			</div>
		);
	}
};

RouteDetailSocials.displayName = "RouteDetailSocials";

RouteDetailSocials.propTypes = {
	routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	routeActive: PropTypes.bool,
	outputs: PropTypes.array,
	outputConfigHandler: PropTypes.func,
	userPerms: PropTypes.object,
	recordPath: PropTypes.func,
	trialEligible: PropTypes.bool
};

RouteDetailSocials.defaultProps = {
	routeId: 0,
	outputs: [],
	routeActive: true,
	outputConfigHandler: null,
	userPerms: {},
	recordPath: null,
	trialEligible: false
};

const enhance = compose(
	SubscriptionModule,
	SocialRestoreModule
);

export default enhance(RouteDetailSocials);
